import React, { Component } from "react";

import {
  CCarousel,
  CCarouselInner,
  CCarouselItem,
  CCarouselControl,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";

import "./style.css";

class LiterarteTip extends Component {
  _getTitle(type) {
    switch (type) {
      case 1:
        return "Artigo de Opinião";
      case 2:
        return "Biografia";
      case 3:
        return "Campanha de Conscientização";
      case 4:
        return "Carta de Solicitação";
      case 5:
        return "Crônica";
      case 6:
        return "E-mail";
      case 7:
        return "Narrativa";
      case 8:
        return "Poesia";
      case 9:
        return "Texto Institucional";
    }
  }

  _getBody(type) {
    switch (type) {
      case 1:
        return (
          <>
            {[...Array(7)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/artigo_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 2:
        return (
          <>
            {[...Array(6)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/biografia_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 3:
        return (
          <>
            {[...Array(6)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/campanha_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 4:
        return (
          <>
            {[...Array(6)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/carta_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 5:
        return (
          <>
            {[...Array(8)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/cronica_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 6:
        return (
          <>
            {[...Array(6)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/email_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 7:
        return (
          <>
            {[...Array(6)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/narrativa_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 8:
        return (
          <>
            {[...Array(4)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/poesia_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
      case 9:
        return (
          <>
            {[...Array(4)].map((_, index) => (
              <CCarouselItem key={index}>
                <img
                  className="w-100"
                  src={`http://escolas.educandus.com.br/app/entrelinhas/images/exemplos/texto_${index}.jpg`}
                  alt={`slide ${index}`}
                />
              </CCarouselItem>
            ))}
          </>
        );
    }
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="lg"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>{this._getTitle(this.props.type)}</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0">
          <CCarousel>
            <CCarouselInner>{this._getBody(this.props.type)}</CCarouselInner>
            <CCarouselControl className="slider-black" direction="prev" />
            <CCarouselControl className="slider-black" direction="next" />
          </CCarousel>
        </CModalBody>
      </CModal>
    );
  }
}

export default LiterarteTip;
